var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.logs, function(log, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(log.created_at))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(log.error))])
                ])
              }),
              0
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success btn--text",
          attrs: { type: "button" },
          on: { click: _vm.reprocesar }
        },
        [
          _c("i", { staticClass: "fa fa-refresh" }),
          _c("span", [_vm._v("Re-procesar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [_c("i", { staticClass: "fa fa-ban" }), _c("span", [_vm._v("Cerrar")])]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [_c("h3", [_vm._v("Logs")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha y hora")]),
        _vm._v(" "),
        _c("th", [_vm._v("Error")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748fb8b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748fb8b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ecas-coparn/LogNoProcesados.vue
// module id = 430
// module chunks = 0